import { RootState } from "../reducers"

export const selectOrdersHistory = (state: RootState) =>
  state.store.ordersHistory

export const selectIsOrdersHistoryFetching = (state: RootState) =>
  state.store.isOrdersHistoryFetching
